"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const Status_1 = require("../Text/Status/Status");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faExclamation_1 = require("@fortawesome/free-solid-svg-icons/faExclamation");
const Labels_1 = require("./Labels");
const colors = {
    neutral: '#8A8985',
    neutralDark: '#6E6D6A',
    negative: '#C04226',
    negativeDark: '#88311E',
    negativeDarker: '#562317',
    disabled: '#C0BEB9',
};
const Base = ({ invalidMessage, rightElement, label, helperText, isRequired, ...props }) => {
    return (react_1.default.createElement(react_2.VStack, { alignItems: 'stretch', gap: 0 },
        react_1.default.createElement(Labels_1.Labels, { label: label, helperText: helperText, isRequired: isRequired }),
        react_1.default.createElement(react_2.VStack, { alignItems: 'flex-start', gap: '4px' },
            react_1.default.createElement(react_2.InputGroup, null,
                react_1.default.createElement(react_2.Input, { borderWidth: '1px', borderStyle: 'solid', borderColor: colors.neutral, transition: '250ms ease-in-out', _placeholder: {
                        fontWeight: 400,
                        fontSize: '14px',
                        color: colors.neutralDark,
                        opacity: 1,
                        transition: '250ms ease-in-out',
                    }, _hover: { borderWidth: '1px', borderStyle: 'solid', borderColor: colors.neutralDark }, _active: { border: '1px solid #4F4E4C' }, focusBorderColor: 'transparent', _focus: { border: '1px solid #006CCF' }, errorBorderColor: 'transparent', _invalid: {
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: colors.negative,
                        bgColor: '#FFF4F0',
                        _placeholder: { color: colors.negative },
                        _hover: {
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: colors.negativeDark,
                            bgColor: '#FFEDE6',
                            _placeholder: { color: colors.negativeDark },
                        },
                        _active: {
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: colors.negativeDarker,
                            bgColor: '#FFDED2',
                            _placeholder: { color: colors.negativeDarker },
                        },
                    }, _disabled: {
                        bgColor: '#E7E5DF',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: colors.disabled,
                        _placeholder: { color: colors.disabled },
                    }, ...props }),
                rightElement && (react_1.default.createElement(react_2.InputRightElement, { color: colors.neutral, _disabled: { color: colors.disabled }, "aria-disabled": props.isDisabled, _invalid: { color: colors.negative }, "aria-invalid": props.isInvalid, transition: '250ms ease-in-out' }, rightElement))),
            react_1.default.createElement(react_2.HStack, { gap: '6px' },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faExclamation_1.faExclamation, color: props.isInvalid && invalidMessage && !props.isDisabled ? '#F2502B' : 'transparent', width: '20px', style: { transition: '250ms ease-in-out' } }),
                react_1.default.createElement(Status_1.Status, { fontSize: '12px', color: props.isInvalid && invalidMessage && !props.isDisabled ? colors.negative : 'transparent', transition: '250ms ease-in-out' }, invalidMessage)))));
};
exports.Base = Base;
